// 'src/comps/nav.tsx'
import { Link, NavLink } from "react-router-dom";
import { Apple } from "lucide-react";
import White_Logo from "../../src/assets/White_logo.png"
import HamburgerMenu from "./HamburgerMenu";

const Nav = () => {
    const hoverStyle =
        "px-2 lg:px-3 py-1.5 lg:py-2 rounded-2xl lg:rounded-3xl transition text-black hover:bg-[#221D23] hover:bg-opacity-20 whitespace-nowrap text-xs md:text-sm lg:text-base focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black/20";

    return (
        <>
            <nav className="hidden md:block sticky top-2 md:top-4
                                        bg-white text-black shadow-xl z-50 justify-self-center rounded-3xl border border-gray-300 w-[95%]
                                            sm:w-11/12 md:w-4/5 lg:w-2/3">
                <div className="container mx-auto max-w-6xl px-3 sm:px-4">
                    <div className="flex items-center justify-between h-14 md:h-16 gap-2 md:gap-4">
                        {/* Logo */}
                        <div className="flex-shrink-0 flex items-center gap-2">
                            <img src={White_Logo} alt="App Logo" className="w-12 h-12" loading="lazy"/>
                            <Link to="/amii" className="text-xl md:text-2xl font-bold text-black">
                                <h1>Amidex</h1>
                            </Link>
                        </div>
                        {/* Navigation */}
                        <div className="flex flex-1 min-w-0 items-center justify-center flex-wrap gap-2 md:gap-4 lg:gap-8">
                            <NavLink to="/amii" end className={({ isActive }) => `${hoverStyle} ${isActive ? "bg-gray-200" : ""}`}>
                                Home
                            </NavLink>
                            <NavLink to="/amii/howtouse" end className={({ isActive }) => `${hoverStyle} ${isActive ? "bg-gray-200" : ""}`}>
                                Instructions
                            </NavLink>
                            <NavLink
                                to="/amii/motivations"
                                className={({ isActive }) => `${hoverStyle} ${isActive ? "bg-gray-200" : ""}`}
                            >
                                Motivations
                            </NavLink>
                        </div>
                        {/* Download Buttons */}
                        <div className="flex items-center shrink-0 gap-2 md:gap-3 lg:gap-4">
                            <button className="flex items-center bg-white text-black border border-gray-300 rounded-2xl lg:rounded-3xl px-3 lg:px-4 py-1.5 lg:py-2 hover:bg-gray-100 transition text-xs md:text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black/20">
                                <Apple className="w-3.5 h-3.5 md:w-4 md:h-4 mr-2 text-black" />
                                <Link to="https://apps.apple.com/us/app/amii-health/id6749024239" target="_blank" rel="noopener noreferrer">App Store</Link>
                            </button>
                        </div>
                    </div>
                </div>
            </nav>
            {/* Mobile Hamburger Menu - visible only on mobile */}
            <nav className="md:hidden flex justify-center w-full">
                <div className="w-[95%] sm:w-11/12 mt-4">
                    <HamburgerMenu />
                </div>
            </nav>
        </>
    );
};

export default Nav;
